import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-subscription-snackbar',
  template: `
    <div class="snackbar-content">
      <mat-icon>task_alt</mat-icon>
      <span
        ><b>{{ data.message }}</b></span
      >
    </div>
  `,
  styles: [
    `
      .snackbar-content {
        display: flex;
        align-items: center;
        color: var(--mat-sys-on-surface);
      }
      mat-icon {
        margin-right: 8px;
        color: var(--mat-sys-primary);
      }
    `,
  ],
  standalone: false,
})
export class SubscriptionSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}
